export default {
  path: 'myNav',
  name: 'myNav',
  component: () => import('@/pages/user/components/myNav.vue'),
  meta: { title: '我的菜单' }
}
